import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import './NavBar.css'
import { NavLink } from "react-router-dom";
const NavBar = (props: any) => {
    const { whichPage, setWhichPageChild, imgClass } = props;
    const [width, setWidth] = useState(window.innerWidth)
    const welcomeClick = () => { setWhichPageChild('welcome') }
    const aboutClick = () => { setWhichPageChild('about') }
    const blogClick = () => { setWhichPageChild('blog') }
    const toolsClick = () => { setWhichPageChild('tools') }
    const articlesClick = () => { setWhichPageChild('articles') }
    const newPostClick = () => { setWhichPageChild('newPost') }
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
    })
    return(
        
           
            <div className={'navbox'}>
                <nav className={'nav'}>
                    <div className={'image-logo'}>
                            <NavLink onClick={welcomeClick} to={'/'}>
                                <img className={imgClass} id={'image'} src={(width < 765) ? 'img/Reactive-Solutions-192x108-white.png' : 'img/Reactive-Solutions-192x108.png'} />
                            </NavLink>
                    </div>
                    <div className={'navigation-links'}>
                        <NavLink onClick={aboutClick} to={'/about'}><span id={'nav-link'} className={whichPage.about ? 'span-underline' : ''}>ABOUT</span></NavLink>
                        <NavLink onClick={blogClick} to={'/blog'}><span id={'nav-link'} className={whichPage.blog ? 'span-underline' : ''}>BLOG</span></NavLink>
                        <NavLink onClick={toolsClick} to={'/tools'}><span id={'nav-link'} className={whichPage.tools ? 'span-underline' : ''}>TOOLS</span></NavLink>
                        <NavLink onClick={articlesClick} to={'/articles'}><span id={'nav-link'} className={whichPage.articles ? 'span-underline' : ''}>ARTICLES</span></NavLink>
                        <NavLink onClick={newPostClick} to={'/create'}><span id={'nav-link'} className={whichPage.newPost ? 'span-underline' : ''}>CREATE</span></NavLink>                    
                    </div>
                </nav>
            </div>
         
    );
}



export default NavBar;